import type { SupabaseClient } from '@supabase/supabase-js'
import type { Database } from './supabase.types.ts'

export type TypedSupabaseClient = SupabaseClient<Database>
